import { useFrame, useThree } from "@react-three/fiber";
import { Canvas } from "@react-three/fiber";
import React, { useEffect } from "react";
import { ClientContext, useClient } from "../../shared/hooks/client-hook";

const ViewPort = ({ children, onCreated }) => {
  return (
    <ClientContext.Consumer>
      {(value) => {
        return (
          <Canvas onCreated={onCreated} fallback={<div>Waiting</div>}>
            <ClientContext.Provider value={value}>
              {children}
            </ClientContext.Provider>
          </Canvas>
        );
      }}
    </ClientContext.Consumer>
  );
};

export default ViewPort;
